const useQuery = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const getParam = (key: string) => {
    return urlParams.get(key) || window.frontTelemedicinaOptions?.[key] || null;
  };

  return {
    get: getParam,
  };
};

export default useQuery;
